import React, { useCallback, MouseEvent } from 'react';

import CheckboxInput from 'components/forms/raw/CheckboxInput';

import './CheckboxCell.scss';

export interface CheckboxCellProps {
  getValue: () => boolean;
  toggle?: () => void;
}

const CheckboxCell = ({ getValue, toggle, ...props }: CheckboxCellProps) => {
  const onClick = useCallback(
    (e: MouseEvent<HTMLInputElement>) => {
      e.stopPropagation();
      toggle?.();
    },
    [toggle],
  );

  return (
    <span {...props} className="enkrateia-center-aligned-cell enkrateia-checkbox-cell">
      <CheckboxInput onClick={onClick} checked={getValue()} />
    </span>
  );
};

export default CheckboxCell;
